/**
 * Return the track/media duration in milliseconds of a track
 * @param audio a partial Track/Media with its optimizedMono and optimizedStereo properties
 * @param type optional parameter to specify if we want the duration of the mono or stereo. Default is mono.
 * @returns the duration in milliseconds or undefined
 */
export const getAudioDuration = (
	audio: {
		optimizedMono?: { duration?: number }
		optimizedStereo?: { duration?: number }
	},
	type: 'stereo' | 'mono' = 'mono'
): number | undefined => {
	return type === 'stereo' ?
			audio.optimizedStereo?.duration
		:	audio.optimizedMono?.duration
}

/**
 * Return the track/media size in bytes of a track
 * @param audio a partial Track/Media with its monoNoMeta and stereoNoMeta properties
 * @param type optional parameter to specify if we want the size of the mono or stereo. Default is mono.
 * @returns the size in bytes or undefined
 */
export const getAudioSize = (
	audio: {
		monoNoMeta?: { sizeBytes?: number }
		stereoNoMeta?: { sizeBytes?: number }
	},
	type: 'stereo' | 'mono' = 'mono'
): number | undefined => {
	return type === 'stereo' ?
			audio.stereoNoMeta?.sizeBytes
		:	audio.monoNoMeta?.sizeBytes
}
